/* global axios */
import ApiClient from './ApiClient';

class ResourceControlsAPI extends ApiClient {
  constructor() {
    super('resource_controls', { accountScoped: true });
  }

  update(key, enabled) {
    return axios.patch(this.url, { resource_control: { key, enabled } });
  }

  updateInboxes(key, inboxIds) {
    return axios.patch(this.url, {
      resource_control: { key, inbox_ids: inboxIds },
    });
  }
}

export default new ResourceControlsAPI();
